// Zustand devtools disabled due to Firefox 49
// See https://jira.co.inbox.lv/browse/MAIL-5095
// import { devtools } from 'zustand/middleware';
import { create } from 'zustand';

import { FAN } from 'containers/Options/Filters/utils';

// const mailFiltersStore = devtools(
const mailFiltersStore = create(
    (set) => ({
        editFilter: { check: 'contains', header: 'From' },
        checkedFilters: [],
        mainChecked: false,
        viewMode: FAN.LIST_FILTERS,

        updateChecked: (id, action) => set(
            (state) => {
                const checkedFilters = state.checkedFilters.slice();
                const index = checkedFilters.indexOf(id);

                if (action === 'add') {
                    if (index === -1) {
                        checkedFilters.push(id);
                    }
                } else if (action === 'remove') {
                    if (index !== -1) {
                        checkedFilters.splice(index, 1);
                    }
                }

                return { checkedFilters };
            }
        ),
        setEditFilter: (obj) => set(
            { editFilter: obj }
        ),
        reSetEditFilter: () => set(
            { editFilter: { check: 'contains', header: 'from' } }
        ),
        setMainChecked: (value) => set(
            { mainChecked: value }
        ),
        setViewMode: (modeName) => set(
            (state) => {
                const viewMode = Object.values(FAN).includes(modeName) ? modeName : FAN.LIST_FILTERS;
                return {
                    viewMode,
                    checkedFilters: viewMode === FAN.LIST_FILTERS ? [] : state.checkedFilters,
                    mainChecked: false
                };
            }
        ),
    })/* ,
    { name: 'mail-filters-store', trace: true } */
);

export default mailFiltersStore;
// export default create(mailFiltersStore);
